module.exports = __webpack_public_path__ + "static/arne-439f576279e2f1068770debaa902417a.png";